import { AfterViewInit, Component, DestroyRef, inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';
import { MemberAuthViewModel } from '../member-auth-view-model';
import { VerifyEmailRequest } from '../../../../../../models/users/requests/verify-email-request';
import { ButtonTypeEnum } from '../../../../../../ui/buttons/button/button-type.enum';
import { TextInputComponent } from '../../../../../../ui/form-components/text-input/text-input.component';

@Component({
  selector: 'app-member-enter-email-verification',
  templateUrl: './member-enter-email-verification.component.html',
  styleUrls: ['./member-enter-email-verification.component.scss', '../../auth.component.scss']
})
export class MemberEnterEmailVerificationComponent implements AfterViewInit {
  private viewModel = inject(MemberAuthViewModel);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  @ViewChild('codeInput', { static: true }) codeInput!: TextInputComponent;

  public authFlowTitle$ = this.viewModel.authFlowTitle$;
  public userEmail$ = this.viewModel.newMemberEmail$;

  public formSubmitted = false;

  public formGroup = new FormGroup({
    code: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required]
    })
  });

  public customErrorMessages = {
    code: {
      required: $localize`Verification code is required`
    }
  };

  private listenToQueryParams = this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
    const email = decodeURIComponent(decodeURIComponent(params?.Email || params?.email || ''));
    if (!!email) {
      this.viewModel.setNewMemberEmail(email);
      this.router.navigate([], { queryParams: {}, replaceUrl: true, relativeTo: this.route }).then();
    }
  });

  public ngAfterViewInit(): void {
    this.codeInput.input.nativeElement.focus();
  }

  public verifyEmail(): void {
    this.formSubmitted = true;
    if (!this.formGroup.valid) return;
    this.viewModel.newMemberEmail$.pipe(take(1)).subscribe(email => {
      const { code } = this.formGroup.getRawValue();
      this.viewModel.verifyMemberEmail(new VerifyEmailRequest(email, code));
    });
  }

  public openContactPage(): void {
    this.viewModel.openContactPage();
  }

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
